import React,{useRef} from 'react'
import styles from '../Pages/NewQuote.module.css';
import axios from 'axios'
import {useNavigate} from 'react-router-dom';

const NewQuotes = () => {


  const usernameInputRef = useRef();
  const quoteInputRef = useRef();

  const navigate = useNavigate();


  const addQuoteHandler = async(e) => {
      e.preventDefault();

      const author = usernameInputRef.current.value;
      const text = quoteInputRef.current.value;

      try {
          const res = await axios.post('https://quotes-app-qrwa.onrender.com/addQuotes', {author,text});
          console.log(res);
          navigate('/'); //to redirect to the allQuotes page after creating a new quote
      }
      catch (e) {
          console.log('Cannot Create Quote at the moment');            
      }

  }


  return (
    <form onSubmit={addQuoteHandler} className={styles['new-quote-form']}>
      <h1> ADD NEW QUOTES </h1>

      <div>
        <label htmlFor="author">Author</label>
        <input type='text' id='author' placeholder='Author Name' ref={usernameInputRef}/>
      </div>

      <div>
        <label htmlFor="quote">Quote</label>
        {/* <input type='text' id='author' placeholder='Author Name' /> */}
        <textarea cols={10} rows={5} placeholder='Write the quotes here ...' ref={quoteInputRef}></textarea>
      </div>

      <button>Submit</button>

    </form>
  )
}

export default NewQuotes